import { render, staticRenderFns } from "./wageDetail.vue?vue&type=template&id=4ea8055a&scoped=true&"
import script from "./wageDetail.vue?vue&type=script&lang=js&"
export * from "./wageDetail.vue?vue&type=script&lang=js&"
import style0 from "./wageDetail.vue?vue&type=style&index=0&id=4ea8055a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8055a",
  null
  
)

export default component.exports